import styled from 'styled-components'

const CardSectionHeader = styled.h3`
	font-weight: 500;
	font-size: 0.875rem;
	line-height: 1.5rem;
	text-transform: uppercase;
	margin: 0 0 1.125rem;
`

export default CardSectionHeader
